import React, { useRef, useState } from 'react';

import './inviteModal.module.scss';


interface EmailInputProps {
  value?: string[];
  onChange: (emails: string[]) => void;
  placeholder?: string;
  label?: string;
}

const EmailInput: React.FC<EmailInputProps> = ({ value = [], onChange, placeholder = 'Enter emails...', label = 'Email' }) => {
  const [input, setInput] = useState('');
  const [emails, setEmails] = useState<string[]>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  const addEmails = (text: string) => {
    const newEmails = text
      .split(/[,\s]+/)
      .map(e => e.trim())
      .filter(e => e && !emails.includes(e));
    if (newEmails.length) {
      const updated = [...emails, ...newEmails];
      setEmails(updated);
      onChange(updated);
    }
  };

  const removeEmail = (email: string) => {
    const updated = emails.filter(e => e !== email);
    setEmails(updated);
    onChange(updated);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keys = ['Enter', ',', 'Tab', ' '];
    if (keys.includes(e.key)) {
      e.preventDefault();
      if (input.trim()) {
        addEmails(input);
        setInput('');
      }
    } else if (e.key === 'Backspace' && !input && emails.length) {
      removeEmail(emails[emails.length - 1]);
    }
  };

  const handleBlur = () => {
    if (input.trim()) {
      addEmails(input);
      setInput('');
    }
  };

  const handleEditEmail = (email: string) => {
    const updated = emails.filter(e => e !== email);
    setEmails(updated);
    setInput(email);
    setTimeout(() => inputRef.current?.focus(), 0); // Ensure DOM is ready
  };

  return (
    <div className="mb-4">
      <label className="block mb-1 text-xs font-semibold text-[#004a66]">{label}</label>
      <div className="scrollable-chips max-h-[100px] overflow-y-auto flex flex-wrap items-center gap-2 px-3 py-2 border border-gray-300 rounded-2xl bg-white focus-within:ring-2 focus-within:ring-blue-400">
        {emails.map((email, i) => (
          <div
            key={i}
            className="flex items-center px-3 py-1 rounded-full border border-gray-300 bg-[#f5f6f7] text-sm"
            onClick={() => handleEditEmail(email)}
          >
            <span className="text-[#1e272c] mr-2">{email}</span>
            <button
              onClick={() => removeEmail(email)}
              className="text-gray-500 hover:text-red-500 text-sm font-bold"
            >
              ×
            </button>
          </div>
        ))}
        <input
          ref={inputRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder={placeholder}
          className="flex-1 min-w-[150px] outline-none border-none text-sm text-[#1e272c] bg-transparent"
        />
      </div>
    </div>
  );
};

export default EmailInput;
